<template>
    <main class="SectionSearch-MAIN">

        <HeaderBand @search-bar-events="(evt, term) => searchBarEvents(evt, term)"/>

        <section class="SectionSearch-history" v-if="(searchbarFocused && searchTerm.trim() == '') || searchTerm.trim() == ''">
            <div>
                <h2>Historial</h2>
                <button @click="deleteAllHistory">Borrar</button>
            </div>
            <div class="search-term-history-container">
                <div v-for="(item, index) in searchHistory" :key="index" class="search-term-history">
                    <img src="../assets/refresh.png"/>
                    <p @click="searchTerm = item, startSearch()">{{ item }}</p>
                    <img src="../assets/close-circle.png" @click="deleteItemFromHistory(item)"/>
                </div>    
            </div>
            <div></div>
        </section>

        <br/>
        <div class="SectionSearch-started-filters" v-if="searchStarted && !searchbarFocused && searchTerm.trim() != ''">
            <div class="hide-scrollbar">
                <button :class="filterBtn == 'all' ? 'active-filter-btn' : ''" @click="filterBtn = 'all'">TODO</button>
                <button :class="filterBtn == 'artists' ? 'active-filter-btn' : ''" @click="filterBtn = 'artists'">ARTISTAS</button>
                <button :class="filterBtn == 'artworks' ? 'active-filter-btn' : ''" @click="filterBtn = 'artworks'">PIEZAS</button>
                <button :class="filterBtn == 'exhibits' ? 'active-filter-btn' : ''" @click="filterBtn = 'exhibits'">EXHIBICIONES</button>
                <button :class="filterBtn == 'articles' ? 'active-filter-btn' : ''" @click="filterBtn = 'articles'">ARTÍCULOS</button>
            </div>
            <div></div>
        </div>

        <section class="SectionSearch-started" v-if="searchStarted && !searchbarFocused && searchTerm.trim() != ''">
            <div class="started-artists" v-if="(filterBtn == 'all' || filterBtn == 'artists') && filteredSearchData.artists.length > 0">
                <h2>
                    <span>Artistas</span>
                    <span class="started-see-more" v-if="filterBtn == 'all'" @click="filterBtn = 'artists'">Ver más</span>
                </h2>
                <div v-for="(item, index) in filteredSearchData[filterBtn == 'artists' ? 'artists' : 'artistsSample']" :key="index" @click="viewArtistProfile(item.id)">
                    <img :src="`${this.$ENDPOINT}/assets/pfp/${item.profilepic}`"/>
                    <div>
                        <div>{{ item.nombre }} {{ item.apellido }}</div>
                        <div>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Et, ratione magnam culpa incidunt hic recusandae sit mollitia in, debitis qui voluptas natus eaque odio deserunt. Laboriosam, unde. Sit repellendus praesentium error voluptatum sed fugit ex consequatur excepturi officia voluptatem, itaque eum, omnis illo maxime quasi sunt architecto? Consequuntur, ullam delectus!</div>
                    </div>
                </div>
            </div>

            <div class="started-artworks" v-if="(filterBtn == 'all' || filterBtn == 'artworks') && filteredSearchData.artworks.length > 0">
                <h2>
                    <span>Piezas</span>
                    <span class="started-see-more" v-if="filterBtn == 'all'" @click="filterBtn = 'artworks'">Ver más</span>
                </h2>
                <div :class="`started-artworks-${filterBtn == 'artworks' ? 'grid' : 'flex'} hide-scrollbar`">
                    <div v-for="(item, index) in filteredSearchData[filterBtn == 'artworks' ? 'artworks' : 'artworksSample']" :key="index" @click="viewArtworkCard(item.id)">
                        <img :src="`${this.$ENDPOINT}/assets/thumbnails_artworks/${item.file}`"/>
                        <p><i>{{ item.titulo }}</i>, {{ item.fecha }}</p>
                        <p>{{ item.artist_nombre }}</p>
                        <p>{{ item.tecnica }}</p>
                    </div>
                </div>
            </div>

            <h2 class="SectionSearch-no-results" v-if="
                (
                    filterBtn == 'all' &&
                    filteredSearchData.artists.length == 0 &&
                    filteredSearchData.artworks.length == 0
                ) || (
                    (filterBtn == 'artists' && filteredSearchData.artists.length == 0) ||
                    (filterBtn == 'artworks' && filteredSearchData.artworks.length == 0)
                )
            ">Sin resultados para "<span>{{ searchTerm }}</span>"</h2>

        </section>

    </main>
</template>

<script>
import HeaderBand from '@/components/HeaderBand.vue';

export default {
    name: 'SectionSearch',
    components: {
        HeaderBand,
    },
    data(){
        return{
            searchTerm: '',
            searchStarted: false,
            searchbarFocused: false,
            searchHistory: [],
            preloadedSearchData: {
                artworks: [],
                artists: [],
            },
            filteredSearchData: {
                artworks: [],
                artworksSample: [],
                artists: [],
                artistsSample: [],
            },
            filterBtn: 'all'
        }
    },
    methods: {
        searchBarEvents(evt, term){
            if(evt == 'focus') return this.searchbarFocused = true;
            if(evt == 'blur') return this.searchbarFocused = false;
            if(evt == 'start') {
                this.searchbarFocused = false;
                this.searchTerm = term;
                this.startSearch();
            }
        },

        startSearch(){
            const searchTerm = this.searchTerm.trim();
            if(!searchTerm || searchTerm == "") return;
            //this.$refs.searchbar.blur();
            this.searchStarted = true;

            const newSearchHistory = this.searchHistory.filter(item => item !== searchTerm);
            this.searchHistory = newSearchHistory;
            this.searchHistory.unshift(searchTerm);

            this.filteredSearchData = {
                artworks: [],
                artists: [],
            };

            for(let i of this.preloadedSearchData.artworks)
                if( JSON.stringify(i).toLowerCase().includes(searchTerm.toLowerCase()) )
                    this.filteredSearchData.artworks.push(i);
            this.filteredSearchData.artworksSample = this.filteredSearchData.artworks.slice(0, 3);

            for(let i of this.preloadedSearchData.artists)
                if( JSON.stringify(i).toLowerCase().includes(searchTerm.toLowerCase()) )
                    this.filteredSearchData.artists.push(i);
            this.filteredSearchData.artistsSample = this.filteredSearchData.artists.slice(0, 3);

            //DEMO:
            const userData = JSON.parse(localStorage.getItem("userData"));
            userData.searchHistory = newSearchHistory;
            localStorage.setItem("userData", JSON.stringify(userData));
            //END DEMO.
        },

        deleteAllHistory(){
            //DEMO:
            const userData = JSON.parse(localStorage.getItem("userData"));
            userData.searchHistory = [];
            localStorage.setItem("userData", JSON.stringify(userData));
            //END DEMO.
            this.searchHistory = [];
        },

        deleteItemFromHistory(searchTerm){
            const newSearchHistory = this.searchHistory.filter(item => item !== searchTerm);
            this.searchHistory = newSearchHistory;

            console.log(searchTerm)

            //DEMO:
            const userData = JSON.parse(localStorage.getItem("userData"));
            userData.searchHistory = this.searchHistory;
            localStorage.setItem("userData", JSON.stringify(userData));
            //END DEMO.
        },

        viewArtworkCard(id){
            this.$router.push({ name: 'artworkcard', params: { id: String(id) } });
        },

        viewArtistProfile(id){
            this.$router.push({ name: 'artistfull', params: { id: String(id) } });
        }
    },
    async mounted() {
        const response = await fetch(`${this.$ENDPOINT}/api/get_search_data.php`);
        const result = await response.json();
        this.preloadedSearchData.artists = result.artistas;
        this.preloadedSearchData.artworks = result.obras;
        
        //DEMO:
		if(!localStorage.getItem("userData")) localStorage.setItem("userData", JSON.stringify({ searchHistory: [] }));
        this.searchHistory = JSON.parse(localStorage.getItem("userData")).searchHistory || [];
		//END DEMO.
    }
}
</script>

<style scoped lang="stylus">
.SectionSearch-MAIN
    background-color: black
    color: white
    height: 100vh
    max-height: 100vh !important

/* section search history */
.SectionSearch-history
    margin: 2vw
    padding: 2vw
    display: flex
    flex-direction: column

    >div:first-child
        display: flex
        align-items: center
        justify-content: space-between

        h2
            font-family: "Archivo ExtraCondensed", sans-serif
            font-weight: 100
            font-size: 5ch
            margin: 0

        button
            background-color: transparent
            border: none
            font-family: "Archivo ExtraCondensed", sans-serif
            font-size: 5vw
            color: white
            opacity: 0.36

    .search-term-history-container
        height: 50dvh
        overflow-y: auto !important
        margin-top: 1ch

    >div:last-child
        width: 100%
        height: 50dvh
        margin-top: -50dvh
        z-index: 1
        background: linear-gradient(transparent, black)
        border: 1px solid black
        pointer-events: none

.search-term-history
    display: flex
    align-items: center
    font-family: "Archivo ExtraCondensed", sans-serif
    font-size: 2.8ch
    margin-bottom: 1.25ch

    >img
        max-width: 2.8ch
        max-height: 2.8ch
        cursor: pointer

        :nth-child(1)
            margin-right: 1ch

        :last-child
            opacity: 0.4;

    p
        margin: 0
        width: 100%
        padding-right: 2.8ch
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis

/* search filters */
.SectionSearch-started-filters
    margin: 0 2vw
    padding: 0 2vw
    position: relative
    display: flex
    align-items: center

    >div:first-child
        width: 100%
        display: flex
        align-items: center
        overflow-x: auto

    button
        margin-right: 1ch
        border-radius: 100vw
        color: white
        border: 1px solid white
        background-color: black
        font-family: "DM Mono", monospace
        padding: 5px 18px

    .active-filter-btn
        background-color: #015AFF !important
        border: 1px solid #015AFF !important

    >div:last-child
        position: absolute
        right: 0
        height: 100%
        width: 15vw
        background: linear-gradient(90deg, transparent, black)
        pointer-events: none
    
/* search started */
.SectionSearch-started
    margin: 2vw
    margin-top: 0
    padding: 2vw
    overflow-y: auto
    display: flex
    flex-direction: column
    height: calc(100% - 16vw - 18vw - (47px + 6vw))
    padding-bottom: calc(47px + 6vw)
    border-radius: 1ch
    mask-image: linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.5) 5%, white 10%, white 80%, transparent 100%)
    -webkit-mask-image: linear-gradient(to bottom, transparent 0%, rgba(0,0,0,0.5) 5%, white 10%, white 80%, transparent 100%)

    h2
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 100
        font-size: 4ch
        margin-bottom: 0.5ch
        display: flex
        align-items: center
        justify-content: space-between

        .started-see-more
            opacity: 0.5
            text-transform: uppercase
            font-family: "DM Mono", monospace !important
            font-size: 0.8ch
            text-decoration: underline
            cursor: pointer

.started-artists > div
    display: flex
    align-items: center
    margin-bottom: 10px
    
    >img
        width: 47px
        aspect-ratio: 1/1 !important
        border-radius: 100vw
        object-fit: cover
        object-position: center
        margin-right: 10px

    >div
        display: flex
        flex-direction: column;
        justify-content: center
        width: calc(100% - 47px - 10px)

    >div
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 100
        white-space: nowrap
        overflow: hidden
        text-overflow: ellipsis

.started-artworks-flex
    display: flex
    width: calc(100% + 2vw)
    overflow-x: auto

    >div
        width: 50vw
        min-width: 50vw
        margin-right: 5vw
        cursor: pointer

        >img
            width: 100%
            aspect-ratio: 3/4
            object-fit: cover
            object-position: center
            border-radius: 5vw
    
        >p:nth-child(2){ font-size: 2.2ch; }
        >p:nth-child(4){ opacity: 0.8; font-size:1.8ch; }

    p
        margin: 0
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 100

.started-artworks-grid
    display: grid
    grid-template-columns: 1fr 1fr
    grid-gap: 2ch

    >div
        margin-bottom: 10px
        cursor: pointer

        >img
            width: 100%
            aspect-ratio: 3/4
            margin-bottom: 5px
            object-fit: cover
            object-position: center
            border-radius: 5vw
        
        >p:nth-child(2){ font-size: 2.2ch; }
        >p:nth-child(4){ opacity: 0.8; font-size:1.8ch; }

    p
        margin: 0
        font-family: "Archivo ExtraCondensed", sans-serif
        font-weight: 100

.SectionSearch-no-results
    font-family: "DM Mono", monospace !important
    font-weight: 200
    width fit-content
    margin: 0 auto
    font-size: 4vw !important
    opacity: 0.5
    text-transform: uppercase;
    margin-top: 3ch
    text-align: center
    display: block !important

    span
        text-transform: none !important
</style>